import { configureStore as toolkitConfigureStore } from "@reduxjs/toolkit";
import rootReducer, { type RootState } from "../reducers";

/**
 * The only caller (`ProviderApp`) passes `undefined`; RTK treats it as "no preloaded state".
 * The parameter is declared as the hydration shape RTK would accept rather than the literal
 * `undefined` the single caller happens to pass, so that the guard below is a real check.
 */
export default function configureStore(preloadedState: Partial<RootState> | undefined) {
  return toolkitConfigureStore({
    reducer: rootReducer,
    // RTK declares `preloadedState?: P`; under `exactOptionalPropertyTypes` the key has to be
    // absent rather than present-and-undefined. RTK's runtime treats an absent key and an explicit
    // `undefined` identically ("no preloaded state"), so the store built here is unchanged.
    ...(preloadedState !== undefined && { preloadedState }),
    devTools: true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // breadCrumbData items may carry render/handler functions (BreadCrumbItem.template) — e.g. the
          // FileExplorer folder breadcrumbs whose crumbs render a clickable node that navigates the tree.
          ignoredPaths: ["fileUploadList", "currentFileUploadProperties", "fileUploadProperties", "breadCrumbData"],
          ignoredActions: [
            "fileUploadList/setFileUploadData",
            "fileUploadList/updateFileUploadData",
            "breadCrumbData/setBreadCrumbData",
          ],
        },
      }),
  });
}
